import React from "react";
import { useNavigate } from "react-router-dom";
import emailIcon from "../../assets/email.png";

function ConfirmationOverlay({ email, onResendClick }) {
  const navigate = useNavigate();

  const navigateToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="overlay">
      <div className="confirmation-modal">
        <button className="close-button">&times;</button>
        <div className="modal-content  ">
          <div>
            <img src={emailIcon} alt="Email Icon" className="email-icon " />
          </div>

          <h2>Email Confirmation</h2>
          <p>
            We have sent you an email to confirm the validity of your email
            address. After receiving it, please follow the link provided to
            complete your registration.
          </p>
          {/* <p>If you did not get any mail</p> */}
          <button className="resend-button" onClick={navigateToLogin}>
            Back to Log In
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationOverlay;
